import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { SCHEDULED_EXPORTS_FEATURE_FLAG } from 'tio-employee/types/scheduled-exports';
import type FeaturesService from 'tio-common/services/features';
import type RouterService from '@ember/routing/router-service';
import type SessionContextService from 'tio-employee/services/session-context';
import { reportingCompanyId } from 'tio-employee/utils/reporting-company';

/**
 * Partner-side scheduled-export history (RFC 080). Read-only by design:
 * scheduling itself lives in tio-admin, so this route shows runs and nothing
 * that creates, edits, pauses or deletes a schedule.
 *
 * Role access is already enforced by the parent `reporting` route
 * (TIO_ADMIN / EMPLOYEE_ADMIN / ACCOUNT_OWNER); this adds the feature-flag
 * kill switch. `reportingScheduledExports` is set in every environment block of
 * `config/environment.js`; flipping it false bounces the route back to the
 * reports index (and hides the entry link) without a code change.
 */
export default class AuthenticatedAdminReportingExportsRoute extends Route {
  @service declare features: FeaturesService;
  @service declare router: RouterService;
  @service declare sessionContext: SessionContextService;

  beforeModel() {
    if (this.features.isDisabled(SCHEDULED_EXPORTS_FEATURE_FLAG)) {
      this.router.transitionTo('authenticated.admin.reporting.index');
    }
  }

  model() {
    const { rolesForCurrentCompany, currentCompany } = this.sessionContext;
    return {
      companyId: reportingCompanyId(rolesForCurrentCompany, currentCompany?.id ?? undefined),
    };
  }
}
